import Ads from "../../../../../app/components/Ads.jsx";

export default function ReactAdTile({ tile }) {
  return <Ads list={[tile.ad]} />;
}
